'use strict';

var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var react = require('react');
var jsxRuntime = require('react/jsx-runtime');

var f=({children:n,show:e,onClose:a,position:i="fixed",disableScroll:o=!1,...s})=>(react.useEffect(()=>(e&&o?document.body.style.overflow="hidden":document.body.style.overflow="",()=>{document.body.style.overflow="";}),[e,o]),e?jsxRuntime.jsx("div",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-overlay overlay overlay-${i}`),onClick:a,...s,children:jsxRuntime.jsx("div",{className:"overlay-content",onClick:d=>d.stopPropagation(),children:n})}):null),c=f;

exports.a = c;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-EUWJVX4V.js.map